var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { padding: "" } },
    [
      _c("q-table", {
        attrs: {
          data: _vm.rewards,
          columns: _vm.columns,
          loading: _vm.loading,
          "row-key": "name",
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "hide-bottom": "",
          pagination: { rowsPerPage: 0 }
        },
        on: { request: _vm.request },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function(props) {
              return [
                _c("div", { staticClass: "col" }),
                _c("q-btn", {
                  attrs: {
                    color: "secondary",
                    icon: "far fa-plus",
                    label: _vm.$t("new")
                  },
                  on: {
                    click: function($event) {
                      return _vm.voucherDialogShow()
                    }
                  }
                })
              ]
            }
          },
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    { key: col.name, attrs: { props: props } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t(col.label)) +
                          "\n            "
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                [
                  _c(
                    "q-td",
                    { key: "id", attrs: { "auto-width": "", props: props } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(props.row.id) +
                          "\n            "
                      )
                    ]
                  ),
                  _c("q-td", { key: "voucher_code", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.voucher_code) +
                        "\n            "
                    )
                  ]),
                  _c("q-td", { key: "user", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.user) +
                        "\n            "
                    )
                  ]),
                  _c("q-td", { key: "created_date", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.formatDate(props.row.created_date)) +
                        "\n            "
                    )
                  ]),
                  _c(
                    "q-td",
                    {
                      key: "status",
                      attrs: { props: props, "auto-width": "" }
                    },
                    [
                      _c(
                        "q-chip",
                        {
                          staticClass: "full-width",
                          attrs: {
                            small: "",
                            icon: _vm.getIconStatus(props.row.status),
                            color: _vm.getColorStatus(props.row.status)
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t(_vm.getStatus(props.row.status))) +
                              "\n                "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "q-td",
                    { key: "actions", attrs: { props: props } },
                    [
                      !props.row.user
                        ? _c(
                            "q-btn",
                            {
                              attrs: {
                                flat: "",
                                round: "",
                                color: "negative",
                                icon: "far fa-trash-alt"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.confirmRemove(props.row.actions)
                                }
                              }
                            },
                            [
                              _c("q-tooltip", [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.$t("delete_tooltip")) +
                                    "\n                    "
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            }
          }
        ])
      }),
      _c(
        "q-dialog",
        {
          on: { ok: _vm.removeItem },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "secondary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.confirm_remove = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("remove") },
                    on: {
                      click: function($event) {
                        return _vm.removeItem()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_remove,
            callback: function($$v) {
              _vm.confirm_remove = $$v
            },
            expression: "confirm_remove"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_item")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_remove_item")))
          ])
        ]
      ),
      _c(
        "q-dialog",
        {
          on: { ok: _vm.removeItem },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "secondary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.show_dialog_reward = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "secondary", label: _vm.$t("add") },
                    on: {
                      click: function($event) {
                        return _vm.confirmVoucherDialog()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.show_dialog_reward,
            callback: function($$v) {
              _vm.show_dialog_reward = $$v
            },
            expression: "show_dialog_reward"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("voucher")))
          ]),
          _c(
            "span",
            { attrs: { slot: "body" }, slot: "body" },
            [
              _c("q-input", {
                attrs: { "float-label": _vm.$t("redeem_code") },
                model: {
                  value: _vm.voucher_dialog_code,
                  callback: function($$v) {
                    _vm.voucher_dialog_code = $$v
                  },
                  expression: "voucher_dialog_code"
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }